import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import SuperAdminList from "../screens/masters/superAdmin/superAdminList";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { name: "Super Admin List" },
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <SuperAdminList />
    </LayoutContainer>
  </>
);

export default Home;
